fragment SubdomainFragment on Subdomain {
    fromDomainId
    record
    formattedRecord
    isVerified
}
